import { useEffect } from 'react'

import { useSelector } from 'react-redux'

import getAccountTracking from 'features/account/helpers/getAccountTracking'

const useTrackPageViewEvent = (pageViewId): any => {
  const appState = useSelector((state) => state)
  const { trackViewEvent } = getAccountTracking(appState)

  const trackPageView = trackViewEvent()

  useEffect(() => {
    trackPageView({ page_id: pageViewId })
  }, [])
}

export default useTrackPageViewEvent
